<h1 mat-dialog-title>Storico stati</h1>

<div mat-dialog-content>
  <div class="map-table-content">
    <mtx-grid
      #grid
      [data]="dataGrid"
      [columns]="columnsGrid"
      [showColumnMenuHeader]="false"
      [noResultText]="'common.no_result' | translate"
      [showFirstLastButtons]="false"
      [showPaginator]="false"
      [emptyValuePlaceholder]="'-'"
      [pageOnFront]="false"
      [sortOnFront]="false"
      [sortDisabled]="true"
    >
    </mtx-grid>
  </div>

  <div mat-dialog-actions align="end">
    <button mat-stroked-button [mat-dialog-close]="false" color="primary">{{ 'common.close' | translate }}</button>
  </div>
</div>

<ng-template #toOpenColTemplate let-row let-col="colDef">
  <mat-icon *ngIf="row.to_open" style="color: green">check</mat-icon>
  <mat-icon *ngIf="!row.to_open" style="color: red">close</mat-icon>
</ng-template>
